import type { FirmData } from '../types/firm';
import { loadFirmData } from '../utils/contentLoader';

// Legacy export for backward compatibility
// This loads data from the new JSON-based content management system
export const firmData: FirmData = loadFirmData().data;

// Export the loader function for components that need validation
export { loadFirmData } from '../utils/contentLoader';